import React from 'react'
import { Alert } from '@ann/web-components'

const ErrorAlert = ({ message, onClose }) => (
    <Alert
        description={message}
        severity="error"
        maxWidth="500px"
        closable={true}
        autoClose={false}
        autoCloseDelay={3000}
        onClose={onClose}
    />
)

export default ErrorAlert
